<template>

    <div v-if="( ( ! addopinion && ! loading ) || ( addopinion ) )" class="question-item" :class="{'add-opinion' : addopinion}">

        <div class="container">

            <div class="row">

                <div class="col-12">

                    <div class="row">

                        <div v-if="(slide.type == 'image' && slide.question.type !== 'goodbad')" class="col-12 col-lg-6 img">
                            <img :alt="slide.title" :src="`/images/projects/${getImageSrc(slide.assets, 'scaled')}`" />
                        </div>

                        <div v-if="slide.type == 'video'" class="col-12 col-lg-6 video">

                            <div v-if="slide.assets.length" class="iframe-wrap">
                                <div class="movie-embed">
                                    <iframe v-if="slide.question.youtube_video" :src="videoUrl" frameborder="0" allow="accelerometer; picture-in-picture" allowfullscreen></iframe>
                                    <iframe v-else-if="!slide.question.youtube_video" :src="videoUrl" frameborder="0" allow="fullscreen" allowfullscreen></iframe>
                                </div>
                            </div>

                            <div v-else>
                                {{ language.no_video }}
                            </div>

                        </div>

                        <div v-if="slide.type == '3D'" class="col-12 col-lg-6 video">
                            <div class="iframe-wrap">
                                <div class="movie-embed" v-html="slide.assets"></div>
                            </div>
                        </div>

                        <form v-if="addopinion" class="col-12" :class="{ 'col-lg-6' : slide.type == 'video' || slide.type == 'image' || slide.type == '3D' }" :ref="'question-' + index">

                            <fieldset class="form-group">

                                <div class="row">

                                    <h2>{{ slide.question.description }}</h2>

                                    <div v-if="slide.question.type == 'freetext' || slide.question.type == 'goodbad'" class="form-group question-freetext">
                                        <add-image-toggle :slideid="slide.id" v-if="slide.question.allow_upload_image && slide.question.type == 'freetext'" />
                                        <textarea class="form-control allowtab-subitem" v-model="dataStore.currentOpinion.comment" id="question-type" name="question" rows="10" />
                                        <small v-if="dataStore.error" class="error">{{ language.required }}</small>
                                    </div>

                                    <div v-if="slide.question.type == 'scale'" class="form-group question-scale">
                                        <scale-options :slide="slide" @multi-value="multiValue" @limit-reached="limitReached" />
                                    </div>

                                    <div class="wrapp">

                                        <remove-image-toggle class="allowtab-subitem" v-if="slide.question.allow_upload_image && slide.question.type == 'freetext'" />

                                        <button :title="language.next" v-if="!dataStore.allowToChange" class="btn btn-primary allowtab-subitem last-form-button special last" :disabled="dataStore.limitOnSlideReached" v-on:click.prevent="addMarkerToText(slide.question.type, $event, parseFloat(slide.id), index)">{{ language.next }}</button>

                                        <a href="#" :title="language.done_submit" class="go-to-last-link allowtab-subitem" v-on:click.prevent="moveToLastPartForm(slide.question.type, $event, parseFloat(slide.id), index)">{{ language.done_submit }}</a>

                                    </div>

                                </div>

                            </fieldset>

                        </form>

                        <div v-if="!addopinion" class="col-12" :class="{ 'col-lg-6' : slide.type == 'video' || (slide.type == 'image' && slide.question.type !== 'goodbad') || slide.type == '3D', 'scale' : slide.question.type === 'scale' }">

                            <h2>
                                {{ slide.question.description !== '' ? slide.question.description : slide.question.title ?? language.comments_on_the_place }}
                            </h2>

                            <p v-if="( ( dataStore.collectedAnswers.filter(item => item.item_id === slide.id).length === 0 && slide.question.type !== 'scale'  )  || ( slide.question.type === 'scale' && dataStore.collectedAnswers.length === 0 ) ) && dataStore.selectedFilters.length === 0">
                                {{ language.no_responses }}
                            </p>

                            <fragment v-else>

                                <chart v-if="slide.question.type === 'scale'" :project="project" :item="slide" :slug="'scales'" />

                                <ul v-else class="opinions">

                                    <li :class="answer.value_type === 'bad' ? 'opinion bad-opinion' : 'opinion'" v-for="(answer,index) in dataStore.collectedAnswers.filter(item => item.item_id === slide.id)" :key="`type-opinion-${index}`">

                                        <div :data-id="answer.id" class="top">

                                            <!-- old scale where hardcoded  -->
                                            <div v-if="answer.question.type == 'scale' && slide.question.options.length === 0">
                                                <p>{{ getScaleValue(answer.values)  }}</p>
                                            </div>

                                            <!-- new scale where option values -->
                                            <div v-if="answer.question.type == 'scale' && slide.question.options.length > 0">
                                                <p v-for="(val, i) in filterListingOptions(answer.values, slide)" :key="i">{{ val.val }}</p>
                                            </div>

                                            <div v-if="(answer.question.type == 'freetext' || answer.question.type == 'goodbad') && answer.comment">
                                                <p>{{ answer.comment }}</p>
                                            </div>

                                            <div v-if="answer.image">
                                                <img class="answer-image" :src="'/images/projects/answer-images/' + getNameAndExt(answer.image).name + '_600.' + getNameAndExt(answer.image).ext" />
                                            </div>

                                        </div>

                                        <div :class="(answer.value_type === 'good' || answer.value_type === 'bad' ? 'bottom' : 'bottom no-after')">

                                            <div :class="(answer.value_type === 'good' || answer.value_type === 'bad' ? 'good-bad' : 'good-bad no-value')">{{ getLabelForGoodBad( language, slide, answer.value_type ) }}</div>

                                            <ul v-if="answer.values && slide.question.type !== 'scale'" class="options ">
                                                <li v-for="(val, i) in filterListingOptions(answer.values, slide)" :key="i">#{{ val.val }}</li>
                                            </ul>

                                            <div v-if="dataStore.project.hide_sex && answer.answer_data && answer.answer_data.sex" :class="(answer.values && answer.values.length) ? 'sex' : 'sex no-options'">{{ answer.answer_data.sex }}</div>

                                            <div v-if="dataStore.project.hide_ages && answer.answer_data && answer.answer_data.age" class="age">{{ answer.answer_data.age }} {{ language.years }}</div>

                                            <div v-if="dataStore.project.hide_types &&answer.answer_data && answer.answer_data.type" class="type">{{ answer.answer_data.type }}</div>

                                            <div class="showonmap" v-if="slide.type == 'map'" @click="show(answer)">{{ language.show_on_map }}</div>

                                            <div class="deeplink" v-if="dataStore.deepLink === answer.deep_link && answer.deep_link.length"></div>

                                            <div class="time-wrapper">

                                                <div class="time" v-if="answer.answer_data && answer.answer_data.created_date">{{ answer.answer_data.created_date }}</div>

                                                <a v-if="project.hide_report && !dataStore.reported.includes(answer.id)" title="Anmäl" href="#" class="report-link" v-on:click.prevent="reportArea(answer.id)">{{ language.report }}</a>

                                                <p class="report-link" v-if="dataStore.reported.includes(answer.id) && project.hide_report">{{ language.has_been_reported }}</p>

                                                <report v-if="project.hide_report && dataStore.currentToReport === answer.id"></report>

                                            </div>

                                        </div>

                                    </li>
                                </ul>

                            </fragment>

                        </div>

                    </div>

                </div>

            </div>
        </div>
    </div>

</template>

<script>

import dataStore from "../../store";

import ScaleOptions from './ScaleOptions'

import AddImageToggle from './../image/AddImageToggle'

import RemoveImageToggle from './../image/RemoveImageToggle'

import Report from './../layout/Report'

import Chart from '../Chart'

import { Fragment } from "vue-fragment";

import { showOnMap } from './../../map-functions'

import { getLabelForGoodBad } from './../../translations'

import { getImageSrc } from './../../image-functions'

import { updateAnswer, removeMarker, addAnswer, showReportArea, markerObject, filtredOptions, getFileInfo, goToNextSlide } from './../../functions'

export default {

    components: {
        AddImageToggle,
        RemoveImageToggle,
        Report,
        Fragment,
        ScaleOptions,
        Chart
    },

    inject: [ 'language', 'loading' ],

    data() {
        return {
            dataStore,
            getImageSrc,
            getLabelForGoodBad
        };
    },

    computed: {

        videoUrl: function() {

            let newAsset

            // Youtube
            if(this.slide.assets.length > 0 && this.slide.question && this.slide.question.youtube_video) {

                if(this.slide.assets.includes('?v=')) {
                    newAsset = this.slide.assets.split('?v=')
                    newAsset = newAsset[1]

                    if(newAsset.includes('&')) {
                        newAsset = newAsset.split('&')
                        newAsset = newAsset[0]
                    }

                    newAsset = 'https://www.youtube.com/embed/' + newAsset

                } else if(this.slide.assets.includes('/embed/')) {
                    newAsset = this.slide.assets
                }

                else {
                    newAsset = 'https://www.youtube.com/embed/' + this.slide.assets
                }

            }

            // Vimeo
            else if(this.slide.assets.length > 0 && this.slide.question && !this.slide.question.youtube_video) {

                if(this.slide.assets.includes('/player.vimeo')) {
                    newAsset = this.slide.assets
                }

                else if(!this.slide.assets.includes('/player.vimeo') && this.slide.assets.includes('https://vimeo.com/')) {
                    newAsset = this.slide.assets.split('https://vimeo.com/')
                    newAsset = newAsset[1]

                    if(newAsset.includes('&')) {
                        newAsset = newAsset.split('&')
                        newAsset = newAsset[0]
                    }

                    newAsset = 'https://player.vimeo.com/video/' + newAsset
                }

                else {
                    newAsset = 'https://player.vimeo.com/video/' + this.slide.assets
                }
            }

            return newAsset

        }
    },

    props: {
        slide : Object,
        index : Number,
        getPinImage : Function,
        addopinion: Boolean,
        project: Object,
    },

    methods: {

        getNameAndExt: function(file) {
            return getFileInfo(file)
        },

        filterListingOptions: function() {
            return filtredOptions.apply(null, arguments)
        },

        reportArea: function(id) {
            return showReportArea(id)
        },

        show: function(answer) {

            this.dataStore.showOnMapPopup = true
            this.dataStore.showOnMapPopupMarker = answer
            
            return showOnMap(answer)
        },

        moveToLastPartForm: function(type, event, slideID, index) {

            if(this.dataStore.limitOnSlideReached) return

            // if(allow) {
            this.addMarkerToText(type, event, slideID, index, false);
            // }
            this.dataStore.showLastPartForm = true;
        },

        addMarkerToText: function(type, event, slideID, index, moveToNextSlide = true) {

            let answer = this.dataStore.collectedAnswers.find((element) => element.item_id == slideID );

            // if it's a multiple scale answer
            if( this.slide.question && this.slide.question.type === 'scale' && this.dataStore.multiAnswers.length ) {

                this.dataStore.currentOpinion.values = this.dataStore.multiAnswers;

                if( answer ) {
                    answer.values = this.dataStore.multiAnswers;
                }

                this.dataStore.multiAnswers = [];
            }

            if( answer ) {

                answer.created = true

                updateAnswer(answer, this.dataStore.currentOpinion.id);
            }

            else {

                let allow = false

                // only add if there is a value
                if( type === 'scale' && this.dataStore.currentOpinion.values ) {

                    const isString = typeof this.dataStore.currentOpinion.values === 'string' || this.dataStore.currentOpinion.values instanceof String

                    const values = ! isString ? this.dataStore.currentOpinion.values : JSON.parse(this.dataStore.currentOpinion.values)

                    if( values.length > 0 ) {
                        allow = true
                    }

                }

                if( type === 'freetext' && this.dataStore.currentOpinion.comment && this.dataStore.currentOpinion.comment.trim().length > 0 ) {
                    allow = true
                }

                if( allow ) {

                    answer = markerObject(null, null, this.slide.id, this.slide.question, this.dataStore.currentOpinion.comment, this.dataStore.currentOpinion.values, this.dataStore.currentOpinion.image);

                    answer.created = true

                    addAnswer(answer);

                }

            }

            this.dataStore.error = false

            if( moveToNextSlide ) {
                goToNextSlide()
            }

            this.dataStore.formPopUpReady = false

        },

        removeFromCollection: function() {
            this.dataStore.currentOpinion.comment = ''
            removeMarker(this.dataStore.currentOpinion)
        },

        getScaleValue: function (values) {

            const scale = [
                { id : 1001, value : this.language.strongly_disagree },
                { id : 1002, value : this.language.disagree },
                { id : 1003, value : this.language.neither },
                { id : 1004, value : this.language.partially_agree },
                { id : 1005, value : this.language.fully_agree }
            ]

            if( values != null && values != "null" && values ) {

                values = JSON.parse(values);

                if( Array.isArray( values ) ) {

                    const id = values[0];

                    const found = scale.find( toFind => toFind.id === id )

                    return found.value

                }

            }

            return
        },

        limitReached: function(isLimitReached) {
            this.dataStore.limitOnSlideReached = isLimitReached
        },

        multiValue: function(array) {
            this.dataStore.multiAnswers = array
        }

    }
};
</script>

